import { z } from 'zod';
import { STATE_TO_UF } from '../properties/utils/masks';

function isValidCpf(cpf: string): boolean {
	const n = cpf.replace(/\D/g, '');
	if (n.length !== 11 || /^(\d)\1{10}$/.test(n)) return false;
	let sum = 0;
	for (let i = 0; i < 9; i++) sum += Number(n[i]) * (10 - i);
	let rem = (sum * 10) % 11;
	if (rem >= 10) rem = 0;
	if (rem !== Number(n[9])) return false;
	sum = 0;
	for (let i = 0; i < 10; i++) sum += Number(n[i]) * (11 - i);
	rem = (sum * 10) % 11;
	if (rem >= 10) rem = 0;
	return rem === Number(n[10]);
}

export const personalDataSchema = z.object({
	name: z.string().min(2, 'Mínimo 2 caracteres'),
	surName: z.string().refine((v) => v === '' || v.length >= 2, 'Mínimo 2 caracteres'),
	document: z.string().refine(isValidCpf, 'CPF inválido'),
	phoneNumber: z.string().refine(
		(v) => v === '' || v.replace(/\D/g, '').length >= 10,
		'Informe DDD + número (ex: (11) 99999-9999)'
	),
	address: z.object({
		zipCode: z.string().refine((v) => v.replace(/\D/g, '').length === 8, 'CEP inválido'),
		street: z.string().min(3, 'Mínimo 3 caracteres'),
		number: z.string().min(1, 'Obrigatório'),
		complement: z.string(),
		district: z.string().min(1, 'Obrigatório'),
		city: z.string().min(1, 'Obrigatório'),
		state: z.string().refine((v) => v in STATE_TO_UF, 'Selecione um estado válido'),
	}),
});

export function parseErrors(schema: z.ZodSchema, data: unknown): Record<string, string> {
	const result = schema.safeParse(data);
	if (result.success) return {};
	return Object.fromEntries(
		result.error.issues.map((issue) => [issue.path.join('.'), issue.message])
	);
}
